import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { DateTime } from 'luxon';
import {
   DashboardAuditSummaryResponse,
   DashboardDataStatus
} from '../../../services/response/user-property-dashboard-response';
import { DashboardCardComponent } from '../dashboard-card/dashboard-card.component';

@Component({
   selector: 'app-dashboard-audit-summary',
   standalone: true,
   imports: [CommonModule, DashboardCardComponent],
   templateUrl: './audit-summary.component.html',
   styleUrls: ['./audit-summary.component.scss']
})
export class AuditSummaryComponent {
   @Input() summary: DashboardAuditSummaryResponse | null = null;
   @Input() dataStatus: DashboardDataStatus | null = null;
   @Input() loading = false;
   @Input() error = false;

   get businessDateLabel(): string | null {
      if (!this.summary?.businessDate) {
         return null;
      }

      return DateTime.fromISO(this.summary.businessDate).toFormat('dd/MM/yyyy');
   }

   formatCurrency(value: number | null | undefined): string {
      return new Intl.NumberFormat('en-AU', {
         style: 'currency',
         currency: 'AUD',
         minimumFractionDigits: 2,
         maximumFractionDigits: 2
      }).format(value ?? 0);
   }

   formatAverage(value: number | null | undefined): string {
      return new Intl.NumberFormat('en-AU', {
         minimumFractionDigits: 0,
         maximumFractionDigits: 0
      }).format(value ?? 0);
   }
}
